import React from 'react';
import { Link } from 'react-router-dom';

export default function ClassroomsDocs({ topic, setTopic, userInfo, schoolType }) {
	const isSupervisor = userInfo && `${userInfo.role_id}` === '3';
	const validTopics = ['search_classrooms', 'sort_classrooms', 'filter_by_department', 'add_classroom', 'edit_classroom', 'select_rows', 'delete_classrooms'].filter(topic_option => !isSupervisor || topic_option !== 'add_classroom');
	const classroomsTopic = validTopics.includes(topic) ? topic : 'default';

	const chooseClassroomsTopic = (newTopic) => {
		if (classroomsTopic === newTopic) {
			setTopic(null);
		} else {
			setTopic(newTopic);
		}
	};

	const videoPlaceholder = { backgroundColor: '#000', borderRadius: '8px', color: '#fff', minHeight: '240px', display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: '20px', padding: '20px', textAlign: 'center' };

	return (
		<div className='documentation-page'>
			<div className='step-main-heading'>Classrooms</div>
			<p className='documentation-question-heading'>What do you need help with?</p>
			<div className='choose-topic'>
				<Link className={`choose-topic-btn ${classroomsTopic === 'search_classrooms' ? 'choose-topic-btn-selected' : ''}`} to={`/app/${schoolType}/documentation/school_data/classrooms/${classroomsTopic === 'search_classrooms' ? 'null' : 'search_classrooms'}`} onClick={() => chooseClassroomsTopic('search_classrooms')}>Search Classrooms</Link>
				<Link className={`choose-topic-btn ${classroomsTopic === 'sort_classrooms' ? 'choose-topic-btn-selected' : ''}`} to={`/app/${schoolType}/documentation/school_data/classrooms/${classroomsTopic === 'sort_classrooms' ? 'null' : 'sort_classrooms'}`} onClick={() => chooseClassroomsTopic('sort_classrooms')}>Sort Classroom Data</Link>
				<Link className={`choose-topic-btn ${classroomsTopic === 'filter_by_department' ? 'choose-topic-btn-selected' : ''}`} to={`/app/${schoolType}/documentation/school_data/classrooms/${classroomsTopic === 'filter_by_department' ? 'null' : 'filter_by_department'}`} onClick={() => chooseClassroomsTopic('filter_by_department')}>Filter By Department</Link>
				{!isSupervisor && <Link className={`choose-topic-btn ${classroomsTopic === 'add_classroom' ? 'choose-topic-btn-selected' : ''}`} to={`/app/${schoolType}/documentation/school_data/classrooms/${classroomsTopic === 'add_classroom' ? 'null' : 'add_classroom'}`} onClick={() => chooseClassroomsTopic('add_classroom')}>Add A Classroom</Link>}
				<Link className={`choose-topic-btn ${classroomsTopic === 'edit_classroom' ? 'choose-topic-btn-selected' : ''}`} to={`/app/${schoolType}/documentation/school_data/classrooms/${classroomsTopic === 'edit_classroom' ? 'null' : 'edit_classroom'}`} onClick={() => chooseClassroomsTopic('edit_classroom')}>Edit A Classroom</Link>
				<Link className={`choose-topic-btn ${classroomsTopic === 'select_rows' ? 'choose-topic-btn-selected' : ''}`} to={`/app/${schoolType}/documentation/school_data/classrooms/${classroomsTopic === 'select_rows' ? 'null' : 'select_rows'}`} onClick={() => chooseClassroomsTopic('select_rows')}>Select Classroom Rows</Link>
				<Link className={`choose-topic-btn ${classroomsTopic === 'delete_classrooms' ? 'choose-topic-btn-selected' : ''}`} to={`/app/${schoolType}/documentation/school_data/classrooms/${classroomsTopic === 'delete_classrooms' ? 'null' : 'delete_classrooms'}`} onClick={() => chooseClassroomsTopic('delete_classrooms')}>Delete Classrooms</Link>
			</div>

			{classroomsTopic === 'search_classrooms' &&
				<div className='documentation-container'>
					<h2 className='documentation-page-heading'>Search Classrooms</h2>
					<div className='documentation-step-text'>Use the search bar to find classrooms by classroom name.</div>
					{!isSupervisor && <div className='documentation-step-text small-text'>Note: Upload is wired in code but the Upload button is currently hidden on this screen.</div>}
					<div style={videoPlaceholder}>Video tutorial coming soon!</div>
				</div>
			}
			{classroomsTopic === 'sort_classrooms' &&
				<div className='documentation-container'>
					<h2 className='documentation-page-heading'>Sort Classroom Data</h2>
					<div className='documentation-step-text'>Sort by Classroom Name or Classroom Type from the column headers.</div>
					<div style={videoPlaceholder}>Video tutorial coming soon!</div>
				</div>
			}
			{classroomsTopic === 'filter_by_department' &&
				<div className='documentation-container'>
					<h2 className='documentation-page-heading'>Filter By Department</h2>
					<div className='documentation-step-text'>Use Department(s) filter to only show classrooms for selected departments.</div>
					<div style={videoPlaceholder}>Video tutorial coming soon!</div>
				</div>
			}
			{classroomsTopic === 'add_classroom' &&
				<div className='documentation-container'>
					<h2 className='documentation-page-heading'>Add A Classroom</h2>
					<div className='documentation-step-text'>Click the plus button in the header row to create a new classroom.</div>
					<div style={videoPlaceholder}>Video tutorial coming soon!</div>
				</div>
			}
			{classroomsTopic === 'edit_classroom' &&
				<div className='documentation-container'>
					<h2 className='documentation-page-heading'>Edit A Classroom</h2>
					<div className='documentation-step-text'>Click the edit icon on a row to update classroom details.</div>
					<div style={videoPlaceholder}>Video tutorial coming soon!</div>
				</div>
			}
			{classroomsTopic === 'select_rows' &&
				<div className='documentation-container'>
					<h2 className='documentation-page-heading'>Select Classroom Rows</h2>
					<div className='documentation-step-text'>Select one or many classrooms, or use Select All for bulk actions.</div>
					<div style={videoPlaceholder}>Video tutorial coming soon!</div>
				</div>
			}
			{classroomsTopic === 'delete_classrooms' &&
				<div className='documentation-container'>
					<h2 className='documentation-page-heading'>Delete Classrooms</h2>
					<div className='documentation-step-text'>Delete one or many selected classrooms with confirmation and optional prompt suppression.</div>
					<div style={videoPlaceholder}>Video tutorial coming soon!</div>
				</div>
			}
		</div>
	);
}
